import { render, staticRenderFns } from "./Irisgem.vue?vue&type=template&id=d97c1706&scoped=true&"
import script from "./Irisgem.vue?vue&type=script&lang=js&"
export * from "./Irisgem.vue?vue&type=script&lang=js&"
import style0 from "./Irisgem.vue?vue&type=style&index=0&id=d97c1706&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97c1706",
  null
  
)

export default component.exports